import { Injectable } from '@angular/core';
import { Firestore,collection, getDocs, query, where, collectionData, doc, getDoc } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor( public firestore: Firestore) { }

  async isAdmin(uid:string) {

    let docRef = doc(this.firestore, `admin/admin`); 
    let result = false;
    const data = await getDoc(docRef);
    for(let i in data.data()){
     if(data.data()[i] == uid){
      result = true;
      break;
     }
    }
    return result;
  }







   /**
   * 
   * @param data 
   * @returns 
   */
    async getUser(email:string):Promise<any> {
      const userCollection = collection(this.firestore, `users`);
      const q = query( userCollection , where("email", "==", email));
      const querySnapshot = await getDocs(q);
      let data;
      querySnapshot.forEach((doc) => {
        data = doc.data();
      });
      
      return new Promise<any>((resolve, reject)=>{
        resolve(data)
      });  
    }
}
